import type { FaireProductEntity } from "../../entity_types/product";

export const p_xx43rg2mez: FaireProductEntity = {
  token: "p_xx43rg2mez",
  type: "product",
  name: "garden flowers paintable watercolor notecard set",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/af9e15287240a9ae339c3fcf50827f8edd4e7986a8115ee3a03daf85ed3af0b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/64c13b8795f068bbd5569a8810f67a5280c26a2c388759bd1ddef96f23ea2f60.jpeg",
    "https://cdn.faire.com/fastly/b78a2aeb0c57e647f78ef4a8874c5d8587c7be2fa860b1f6a58ab140dcba71e4.jpeg",
    "https://cdn.faire.com/fastly/99dbcc28c95c1bc8a68deca3b98306e90e77b337aefb40084ab3ba4eb49e00e0.jpeg",
    "https://cdn.faire.com/fastly/1be481840c4ac3133defb8fa4063cc6bafeca5448bf92779822816402757dc6c.jpeg",
    "https://cdn.faire.com/fastly/1f9823bd9007574bd3900eaa4e0fea147359f478e7e75e1e487942063b78d64e.jpeg",
    "https://cdn.faire.com/fastly/cc1f277c39c02f747130bc965b33ef031b58320f7a25d5dbd23f3b333715053f.jpeg",
    "https://cdn.faire.com/fastly/c64e91285d26588d14f63db07a042b8c5ab0eb556e717c0b3855ff74a6bd20cf.jpeg",
    "https://cdn.faire.com/fastly/75ec467c6a49bf88a71a32b3fcb92deb4947949d8aaeb2d9539d92e09c4ce97a.jpeg",
    "https://cdn.faire.com/fastly/f4a7a5be51b17076bd88c01ef8588176bc08ce1d2a3d03b07f898f32d2818f69.jpeg",
    "https://cdn.faire.com/fastly/e2d5bbc279a4daae1b75d6b48dd8f558a6d1a423caaab9207bddddf917112151.jpeg",
    "https://cdn.faire.com/fastly/6547ff2d39e18574890743330b11af0a95b044f29ee729823f0bd1ccbc2a34b1.jpeg",
    "https://cdn.faire.com/fastly/10375a449900e5e197789c01a14ea07253fdd4b11446db744004dadaed40161b.jpeg",
    "https://cdn.faire.com/fastly/bb98befe49007b22a0d7c8ebb8ad998d1b96984f54a91f6dc9978cc6d0aa389c.jpeg",
  ],
  priceDollars: 9,
  description:
    "\n\nA consistent reorder and a natural companion to the watercolor workbook and paint set. Customers paint the cards themselves and send them — no experience necessary, simple instructions included.\n\nIllustrations: hydrangea, garden rose, delphinium, daisy.\n\n$9 wholesale · $18 retail · set of eight notecards + envelope\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:14.391Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
